/*
 * Purpose : Common component for input elements
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from 'react'
import { FormGroup, Label, Input } from "reactstrap";

function CustInput (props) {
  const { labelText, id, required, ...rest } = props
  return (      
    <FormGroup>
      <Label for={id}>
        {required ? <>{labelText}&nbsp;&nbsp;<b style={{ color: "red" }}>*</b></>:<>{labelText}</>}
      </Label>
      <Input {...rest} required>{props.children}</Input>
      {/* <p>I am the content here</p> */}
    </FormGroup>
  )
}

export default CustInput
